import React from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { teamNameCategory, TeamNameCategory } from '../../../schemas/dispatch';

interface Props {
    value: TeamNameCategory[];
    setValue: React.Dispatch<React.SetStateAction<TeamNameCategory[]>>;
    zIndex: number;
}

function CategoriesDropdown({ value, setValue, zIndex }: Props) {
    return (
        <FilterDropdown
            label={translate('category')}
            items={Object.values(teamNameCategory).map((item: string) => {
                return {
                    label: item ? translate(item) : '', value: item
                };
            })}
            mode='BADGE'
            multiple={true}
            value={value}
            setValue={setValue}
            zIndex={zIndex}
        />
    );
}

export default CategoriesDropdown;
